import { Payload, usePost } from 'api/reactQuery/queryService';
import { APIRoutes } from './constants';

const CalculateLotsParser = (response) => {
    return {
        ...response,
    };
};
export const useCalculateBinLocations = () => {
    return usePost<Payload<{ ProductId: number; Warehouse: number } & any>, any>
        (APIRoutes.BinLocation.calculateLots, null, { responseParser: CalculateLotsParser });
};
